/** Как frontend / gDaksby: в API только 9 цифр (375XXXXXXXX → XXXXXXXXX). */
export function normalizePhoneForApi(input: string): string {
  const digits = input.replace(/\D/g, "")
  if (digits.length >= 9) {
    return digits.slice(-9)
  }
  return digits
}

const BY_MOBILE_RE = /^(17|25|29|33|44)\d{7}$/

export function validateBelarusMobileNineDigits(nineDigits: string): string | null {
  if (nineDigits.length !== 9) {
    return "Введите номер полностью (+375 и 9 цифр)"
  }
  if (!BY_MOBILE_RE.test(nineDigits)) {
    return "Проверьте код оператора (17, 25, 29, 33, 44)"
  }
  return null
}

export function formatBelarusPhoneDisplay(nineDigits: string): string {
  if (nineDigits.length !== 9) return nineDigits
  return `+375 ${nineDigits.slice(0, 2)} ${nineDigits.slice(2)}`
}

function isAxiosLikeError(err: unknown): err is {
  response?: { data?: { message?: unknown } }
} {
  return typeof err === "object" && err !== null && "response" in err
}

export function authErrorMessage(
  err: unknown,
  fallback: string
): string {
  if (!isAxiosLikeError(err)) return fallback
  const msg = err.response?.data?.message
  return typeof msg === "string" && msg.trim() ? msg : fallback
}
